import { render } from "./ads.Shoesandsandles.vue?vue&type=template&id=8152433e"
import script from "./ads.Shoesandsandles.vue?vue&type=script&lang=js"
export * from "./ads.Shoesandsandles.vue?vue&type=script&lang=js"

import "./ads.Shoesandsandles.vue?vue&type=style&index=0&id=8152433e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__